const featureFlags = {
  enableTodoBadgeCount: true,
  enableSupportAgent: false,
  // Personal start page ("Cockpit") on "/" — set false to fall back to the
  // news feed as the root page (sidebar + startup screen adapt).
  enableCockpit: true,
};

export default featureFlags;
